module.exports = __webpack_public_path__ + "static/img/video-tagging.70cb744.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/video-tagging.png
// module id = Nc3t
// module chunks = 1